export const OpeningHoursConstantTableHeaders = [
  "opened-from",
  "opened-to",
  "type",
  "opened",
  "modify",
  "delete",
];
